<div>WE EXTEND THIS CLASS AS BASE CLASS WE WONT USE THE HTML HERE</div>